import { useTranslation } from "react-i18next";
import {
  getCommonMisconception,
  useCreateCommonMisconception,
  useGetCommonMisconception,
} from "@packages/api/madlenAPI";
import { CommonMisconceptionResponseDto } from "@packages/api/madlenAPI.schemas";
import CreateModal, {
  CreateModalProps,
} from "../../../components/create-modal";
import MisconceptionCard from "../../../components/misconceptions/MisconceptionCard";
import GenericToolCreationPage from "../../../components/tool_components/GenericToolCreationPage";

const CreateMisconceptionView = () => {
  const { t } = useTranslation();

  const CreateModalWrapper = ({
    initialInput,
    onSubmit,
    isLoading,
    error,
  }: Partial<CreateModalProps>) => (
    <CreateModal
      title={t("misconceptions.result.loading.title")}
      backPath="/content/misconceptions"
      themeColor="red"
      loadingTitle={t("misconceptions.result.loading.title")}
      errorTitle={t("misconceptions.result.error.title")}
      errorDescription={t("misconceptions.result.error.description")}
      submitButtonText={t("common.generate")}
      initialInput={initialInput!}
      onSubmit={onSubmit!}
      isLoading={isLoading!}
      error={error!}
    />
  );

  const ToolCardWrapper = ({
    toolData,
    onCreateAgain,
  }: {
    toolData: CommonMisconceptionResponseDto;
    onCreateAgain: () => void;
  }) => (
    <MisconceptionCard misconception={toolData} onCreateAgain={onCreateAgain} />
  );

  return (
    <GenericToolCreationPage
      toolType="misconceptions"
      useCreateTool={useCreateCommonMisconception}
      useGetTool={useGetCommonMisconception}
      getTool={getCommonMisconception}
      ToolCard={ToolCardWrapper}
      CreateModalWrapper={CreateModalWrapper}
      toolDataExtractor={(data: CommonMisconceptionResponseDto) =>
        data?.misconceptions &&
        Array.isArray(data?.misconceptions) &&
        data?.misconceptions?.length > 0
      }
    />
  );
};

export default CreateMisconceptionView;
